import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/imgs/qq_icon.png';
import _imports_1 from '@/assets/imgs/wechat_ewm6.png';
const _hoisted_1 = {
  key: 0,
  class: "global-footer"
};
const _hoisted_2 = {
  class: "global-con"
};
const _hoisted_3 = {
  class: "global-menu"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "link-menu"
};
const _hoisted_6 = {
  class: "contact-us"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "qq-contact",
  href: "http://wpa.qq.com/msgrd?v=3&uin=2851655063&site=qq&menu=yes"
};
const _hoisted_9 = {
  class: "service"
};
const _hoisted_10 = {
  class: "item-txt"
};
const _hoisted_11 = {
  class: "label"
};
const _hoisted_12 = {
  class: "item-txt"
};
const _hoisted_13 = {
  class: "label"
};
const _hoisted_14 = {
  class: "ewm-box"
};
const _hoisted_15 = {
  class: "txt"
};
import { FooterBlackList } from '@/utils/const';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    return (_ctx, _cache) => {
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock("div", null, [!_unref(FooterBlackList).includes(_unref(route).path) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('home.text127')), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", {
        class: "link-txt",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push(`/aboutUs?className=company-profile`))
      }, _toDisplayString(_ctx.$t('home.text128')), 1), _createElementVNode("span", {
        class: "link-txt",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push(`/aboutUs?className=development-history`))
      }, _toDisplayString(_ctx.$t('home.text129')), 1), _createElementVNode("span", {
        class: "link-txt",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push(`/aboutUs?className=corporate-culture`))
      }, _toDisplayString(_ctx.$t('home.text130')), 1), _createElementVNode("span", {
        class: "link-txt",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push(`/aboutUs?className=corporate-honors`))
      }, _toDisplayString(_ctx.$t('home.text131')), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('home.text132')), 1), _createElementVNode("a", _hoisted_8, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "icon",
        src: _imports_0
      }, null, -1)), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('home.text133')), 1)]), _createElementVNode("p", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('home.text134')), 1), _cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "value"
      }, "028-83316191", -1))]), _createElementVNode("p", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('home.text135')), 1), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "value"
      }, "199-8206-5680（张经理）", -1))])]), _createElementVNode("div", _hoisted_14, [_cache[7] || (_cache[7] = _createElementVNode("img", {
        class: "ewm",
        src: _imports_1
      }, null, -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('home.text136')), 1)])]), _createVNode(_component_AdvisoryService, {
        ref: "advisoryServiceRef"
      }, null, 512)])) : _createCommentVNode("", true), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "portal-footer1"
      }, [_createElementVNode("span", {
        class: "copyright"
      }, "Copyright@2015 -2023 jeemaa.com All Rights Reserved"), _createElementVNode("span", {
        class: "permission"
      }, [_createTextVNode(" 增值电信业务经营许可证：川B2-20160113 | 版权所有·成都优译 "), _createElementVNode("a", {
        href: "https://beian.miit.gov.cn",
        target: "_blank"
      }, "蜀ICP备11013193号")])], -1))]);
    };
  }
});